module.exports = __webpack_public_path__ + "img/mountain-arena.5f32bb18.jpg";